function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#2196f3",
    d: "M 28.5,-0.5 C 87.5,-0.5 146.5,-0.5 205.5,-0.5C 220.582,4.08491 230.082,14.0849 234,29.5C 234.667,66.5 234.667,103.5 234,140.5C 230.05,156.784 219.883,166.617 203.5,170C 145.5,170.667 87.5,170.667 29.5,170C 14.0849,166.082 4.08491,156.582 -0.5,141.5C -0.5,103.5 -0.5,65.5 -0.5,27.5C 4.2711,13.0617 13.9378,3.72837 28.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#1976d2",
    d: "M 305.5,-0.5 C 364.5,-0.5 423.5,-0.5 482.5,-0.5C 497.5,3.83333 507.167,13.5 511.5,28.5C 511.5,108.833 511.5,189.167 511.5,269.5C 506.915,284.582 496.915,294.082 481.5,298C 423.5,298.667 365.5,298.667 307.5,298C 291.117,294.617 280.95,284.784 277,268.5C 276.333,188.833 276.333,109.167 277,29.5C 280.918,14.0849 290.418,4.08491 305.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#1975d2",
    d: "M 205.5,511.5 C 146.5,511.5 87.5,511.5 28.5,511.5C 13.5,507.167 3.83333,497.5 -0.5,482.5C -0.5,402.167 -0.5,321.833 -0.5,241.5C 4.08491,226.418 14.0849,216.918 29.5,213C 87.8333,212.333 146.167,212.333 204.5,213C 220.333,216.833 230.167,226.667 234,242.5C 234.667,322.167 234.667,401.833 234,481.5C 230.082,496.915 220.582,506.915 205.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#2196f3",
    d: "M 511.5,369.5 C 511.5,407.167 511.5,444.833 511.5,482.5C 507.167,497.5 497.5,507.167 482.5,511.5C 423.5,511.5 364.5,511.5 305.5,511.5C 290.418,506.915 280.918,496.915 277,481.5C 276.333,444.5 276.333,407.5 277,370.5C 280.833,354.667 290.667,344.833 306.5,341C 364.833,340.333 423.167,340.333 481.5,341C 496.915,344.918 506.915,354.418 511.5,369.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ccbe53486f919337cf287efabfea929e.svg";
export { ForwardRef as ReactComponent };